<template>
  <PopupTemplate @close="$emit('close')">
    <NuevoTelefono v-if="paso == 'pedirTelefono'" @siguiente="siguiente" />
    <SeleccionPolizas v-if="paso == 'aplicarPolizas'" :campo="'telefono'" @siguiente="siguiente" />
    <ResultadoCambio v-if="paso == 'resultado'" :campo="'telefono'" @siguiente="siguiente" />
    <div v-if="errorTelefono" class="noValido">{{ errorTelefono }}</div>
  </PopupTemplate>
</template>

<script>
export default {
  props: {
    idPoliza: { type: Number, required: false, default: 0 },
    ramo: { type: String, required: false, default: "" },
  },

  data() {
    return {
      paso: "pedirTelefono",
      errorTelefono: "",
    };
  },

  computed: {
    tieneMasDeUnaPoliza() {
      return this.$store.state.portfolio.totalPolizasVigorMMT > 1;
    },
    telefAtencion() {
      return this.$store.state.telefonoAtencion;
    },
    telefAtencionGratuito() {
      return this.$store.state.telefonoAtencionGratuito;
    },
  },

  methods: {
    actualizarTelefono: async function () {
      console.log("Actualizar teléfono: " + this.$store.state.nuevoTelefono + " en pólizas:" + this.$store.state.polizasSel);
      let result = await this.$store.dispatch("actualizarTelefono", {
        telefono: this.$store.state.nuevoTelefono,
        polizas: this.$store.state.polizasSel,
      });

      console.log(result);
      if (result.codigo != 0 && result.codigo == 1010) {
        this.errorTelefono = result.mensaje;
        return;
      } else if (result.codigo != 0) {
        this.errorTelefono = "Se ha producido un error. Por favor, contacte con Atención al Cliente en los teléfonos "
          + this.telefAtencionGratuito + " o " + this.telefAtencion;
        return;
      } else {
        this.errorTelefono = "";
      }
      this.$store.dispatch("getPortfolio");

      this.paso = "resultado";
    },

    siguiente: async function () {
      switch (this.paso) {
        case "pedirTelefono":

          if (this.tieneMasDeUnaPoliza) {
            // Pasamos a seleccionar la poliza
            console.log("Tiene mas de una poliza : " + this.tieneMasDeUnaPoliza);
            this.paso = "aplicarPolizas";
          } else {

            if (this.$store.state.portfolio.lstPolizasSaludHNA.length == 1) {
              // En este caso solo se cambia el cliente
              const arrayPoliza = new Array();
              this.$store.dispatch("setPolizasSel", arrayPoliza);
              this.actualizarTelefono();
            } else {

              const arrayPoliza = new Array();
              if (this.$store.state.portfolio.lstPolizasHogar.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasHogar[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasVeh.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasVeh[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasDec.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasDec[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasMovilidad.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasMovilidad[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasNegocio.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasNegocio[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasAccidentes.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasAccidentes[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasMascotas.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasMascotas[0].idPoliza);
              }
              if (this.$store.state.portfolio.lstPolizasSaludMMT.length > 0) {
                arrayPoliza.push(this.$store.state.portfolio.lstPolizasSaludMMT[0].idPoliza);
              }
              this.$store.dispatch("setPolizasSel", arrayPoliza);
              this.actualizarTelefono();
            }

          }

          break;

        case "aplicarPolizas":
          this.actualizarTelefono();
          break;
        case "resultado":
          this.$emit("close");
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.noValido {
  color: red;
  font-weight: bold;
}

.cabecera {
  font-size: 120%;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}

.texto {
  font-size: 90%;
  margin-bottom: 1rem;
  color: $azulOscuroMMT;
}

.panel {
  display: flex;
  flex-flow: column nowrap;

  label {
    display: block;
  }

  input {
    width: 100%;
  }

  button {
    background-color: $colorMMT;
    color: white;
    margin-top: 1rem;
  }
}

.contenedor {
  width: 100%;
  max-width: 30rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding: 2rem;
}

.sep {
  height: 0.8rem;
}
</style>
